document.addEventListener('DOMContentLoaded', function() {
  const ctx = document.getElementById('myChart').getContext('2d');
  const data = {
    labels: ['Pickle Juice', 'Water-Only'],
    datasets: [{
      data: [0, 0], // Start with empty data
      backgroundColor: ['#4CAF50', '#2196F3'], // Example colors
    }]
  };

  const myPieChart = new Chart(ctx, {
    type: 'doughnut',
    data: data,
    options: {
      responsive: true,
      animation: {
        duration: 0 // Disable initial animation
      }
    }
  });

  let rotationCount = 0;
  const totalRotations = 6;
  const rotationDuration = 3000; // Duration of each full rotation in milliseconds

  function performRotation() {
    // First half rotation for "Pickle Juice"
    data.datasets[0].data = [50, 0];
    myPieChart.update();

    // Full rotation for "Water-Only"
    setTimeout(() => {
      data.datasets[0].data = [0, 100];
      myPieChart.update();

      // Pause for 3 seconds then perform the next rotation
      setTimeout(() => {
        rotationCount++;
        if (rotationCount < totalRotations) {
          performRotation();
        }
      }, rotationDuration);
    }, rotationDuration / 2);
  }

  performRotation();
});
